import {useQuery} from '@apollo/client';
import {DOCUMENT_UPLOADER_FORM_CONFIGS} from '../graphql/queries';
import {
  documentUploaderFormConfigs,
  documentUploaderFormConfigs_documentUploaderFormConfigs,
} from '../schema-types/documentUploaderFormConfigs';

export interface ValueStringLabel {
  value: string;
  label: string;
}

const getNestedCategories = (
  categories: (documentUploaderFormConfigs_documentUploaderFormConfigs | null)[]
) => {
  const payload: Record<string, ValueStringLabel[]> = {};
  categories.forEach((x) => {
    if (!x?.category) {
      return;
    }
    if (!(x.category in payload)) {
      payload[x.category] = [];
    }
    payload[x.category].push({
      value: String(x.enumName),
      label: String(x.subcategory),
    });
  });
  return payload;
};

export type FormConfigRecord = Record<
  string,
  documentUploaderFormConfigs_documentUploaderFormConfigs
>;

const getFormConfig = (
  categories: (documentUploaderFormConfigs_documentUploaderFormConfigs | null)[]
) => {
  const payload: FormConfigRecord = {};
  categories.forEach((x) => {
    if (!x?.enumName) {
      return;
    }
    payload[x.enumName] = {...x};
  });
  return payload;
};

export const useDocumentUploaderFormConfigs = () => {
  const {loading, data, error} = useQuery<documentUploaderFormConfigs>(
    DOCUMENT_UPLOADER_FORM_CONFIGS,
    {
      fetchPolicy: 'cache-first',
    }
  );

  const config = data?.documentUploaderFormConfigs || [];

  return {
    loading,
    formConfig: getFormConfig(config),
    nestedCategories: getNestedCategories(config),
    error,
  };
};
